import { helpers, required, requiredIf } from '@vuelidate/validators';
import ApplicationsResidenceStatus from './ApplicationsResidenceStatus';
import LOCALIZATION from '../Localization';
import moment from 'moment';
import { validZIPUS } from '@core/services/custom-validators';
import AddressBase from '../_Base/AddressBase';
export default class ApplicationsResidence extends AddressBase {
	constructor(init) {
		super(init);
		this.movedInDate = null;
		this.homePhoneNumber = null;
		this.residenceStatus = new ApplicationsResidenceStatus();

		if (init) {
			this.movedInDate = init.movedInDate ? moment(init.movedInDate, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]').format('YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]') : init.movedInDate;
			this.homePhoneNumber = init.homePhoneNumber;
			this.residenceStatus = new ApplicationsResidenceStatus(init.residenceStatus);
		}

		this.usingUSAddress = this.country != null ? this.country == 'US' : null;
	}

	getMovedInDateFormatted() {
		if (this.movedInDate) {
			let movedIn = moment(this.movedInDate, ['YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]', 'MM/DD/YYYY']).format('MM/DD/YYYY');
			return movedIn;
		}
	}

	/** When making an update, call the method */
	updateUsingUSAddress() {
		this.usingUSAddress = this.country !== null ? this.country === 'US' : null;
	}

	validation(includeResidenceStatus = false, language = 'English') {
		const validationRules = super.validation(language); // Get validation from AddressBase

		if (includeResidenceStatus) {
			validationRules.residenceStatus = this.residenceStatus.validation(language);
		}

		return validationRules;
	}
}
